<ng-container *ngFor="let iTag of tags">
    <div [style.background-color]="iTag.color" [style.color]="iTag.textColor" class="tagItem">{{iTag.name}}</div>
</ng-container>